import type { Technique } from '../types';
import { HEIGHT_FIELD_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type HeightFieldState } from './render';

export const heightField: Technique<HeightFieldState> = {
  id: 'height-field',
  name: 'Noise-Displacement in Z',
  category: 'dimension',
  description: 'Die Textfläche als Höhenfeld, verzerrt durch Rauschen — solid, als Gitter oder als Schnittlinien.',
  params: HEIGHT_FIELD_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
